<template lang="pug">
#sectionTool
  .appTools
    .level(@click="selectSection")
      .type(:title="sectionData.name")
        span 模式：
        img(:src='sectionData.icon' :title='sectionData.name' alt='图标')
        span {{sectionData.name}}
      i.el-icon-arrow-up
    .level
      el-checkbox(v-model="showSectionHandle",size="mini" @change="startSection") 显示把手
      el-checkbox(v-model="showSectionPlane",size="mini" @change="startSection") 显示剖面
      el-checkbox(v-model="showSectionFill",size="mini" @change="startSection" ) 剖面填充
    i.el-icon-minus.close(title="最小化",@click="closeAdd")
  //- 剖切模式
  transition(name="el-fade-in-linea")
    .sectionType(v-if="sectionShow")
      .chil(v-for="item in sectionList" :key="item.query" :class="{'isActive': item.query == sectionData.query}" @click="changeSection(item)")
        img(:src="item.icon" :title='item.name' alt='图标')
        span {{item.name}}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";

export default {
  data () {
    return {
      sectionFuncList: [
        { name: "X轴", icon: require("./../images/X轴.png"), query: "x", isActive: false },
        { name: "Y轴", icon: require("./../images/Y轴.png"), query: "y", isActive: false },
        { name: "Z轴", icon: require("./../images/Z轴.png"), query: "z", isActive: false },
        { name: "盒子", icon: require("./../images/盒子.png"), query: "box", isActive: false },
        { name: "拾取面", icon: require("./../images/截取面.png"), query: "custom", isActive: false },
        { name: "构件剖切", icon: require("./../images/截取面.png"), query: "art", isActive: false }
        // { name: "清除剖切", icon: require("./../../images/清除测量.png"), query: "close", isActive: false},
      ],
      sectionData: {},
      showSectionPlane: true, // 是否显示剖切平面，默认为true
      showSectionHandle: true, // 是否显示剖切把手，默认为true
      showSectionFill: true, // 是否显示填充面，默认为true
      sectionShow: false

    };
  },
  computed: {
    // 是否是无轻量化的模型
    isNoLightweight() {
      return mongeApp.model.isNoLightweight;
    },
    sectionList() {
      return this.isNoLightweight ? this.sectionFuncList.slice(0, 3) : this.sectionFuncList;
    }
  },
  mounted () {
    this.sectionData = this.sectionList[0];
    this.startSection();
  },
  methods: {
    selectSection() {
      this.sectionShow = !this.sectionShow;
    },
    closeAdd() {
      this.$emit("closeCom", 'section', true);
    },
    changeSection(item) {
      this.sectionData = item;
      this.sectionShow = false;
      this.startSection();
    },
    startSection() {
      mongeApiMlib.section3D(this.sectionData.query, this.showSectionPlane, this.showSectionHandle, this.showSectionFill);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
.appTools{
  width: 440px;
}
.sectionType{
  position: absolute;
  width: 125px;
  height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  left: calc(50% - 200px);
  bottom: 35px;
  padding: 5px 0;
  z-index: 4;
  .chil{
    padding: 0 14px;
    margin-top: 2px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .chil:hover{
    background: rgba(56, 115, 254, 0.18);
  }
  .isActive{
    background: rgba(56, 115, 254, 0.18);
  }
}
</style>
